import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./curatedListingTile.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { APPX_SITE_URL } from '~/modules/config';
import { getCategoryTagsForTiles, getListingLogo } from '~/modules/helpers/listingHelper';
import { Routes } from '~/modules/routes';
import { listingStore, selectListing } from '~/modules/stores/listingStore';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
class CuratedListingTile extends LightningElement {
  constructor(...args) {
    super(...args);
    this.isLoading = true;
  }
  get listingAsArray() {
    return !this.isLoading && !!this.listing ? [this.listing] : [];
  }
  set listingId(listingId) {
    this._listingId = listingId;
    this.isLoading = true;
    this.listing = undefined;
    // In the WordPress editor these are defaulted to undefined, prevent exception by just not trying to fetch.
    if (listingId) {
      this.setOrFetchListing();
    }
  }
  get listingId() {
    return this._listingId;
  }
  updateListing(state) {
    if (!state.isLoading) {
      const listing = selectListing(state, this._listingId);
      if (listing) {
        this.listing = {
          external_id: listing.external_id || '',
          oafId: listing.external_id || '',
          tzId: listing.tzId || '',
          appExchangeId: listing.appExchangeId || '',
          listingUrl: `${APPX_SITE_URL}/${Routes.LISTING}?listingId=${listing.external_id}`,
          averageRating: listing.reviewsSummary?.averageRating ?? 0,
          reviewsAmount: listing.reviewsSummary?.reviewCount ?? 0,
          publisher: listing.publisher?.name,
          listingCategories: getCategoryTagsForTiles(listing),
          image: getListingLogo(listing),
          title: listing.name,
          description: listing.description,
          type: this.getListingType(listing) || '',
          chatEnabled: false,
          sponsored: false
        };
        this.isLoading = false;
        return true;
      }
    }
    return false;
  }
  getListingType(listing) {
    const extension = selectExtensionListing(listing);
    return extension.recordType;
  }
  setOrFetchListing() {
    if (!this.updateListing(listingStore.getState())) {
      listingStore.fetchListing(this._listingId);
    }
  }
  listingsChanged(state) {
    if (!state.isLoading) {
      this.updateListing(state);
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(CuratedListingTile, {
  publicProps: {
    listingId: {
      config: 3
    }
  },
  wire: {
    listingsChanged: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: listingStore
        };
      }
    }
  },
  fields: ["isLoading"]
});
const __lwc_component_class_internal = _registerComponent(CuratedListingTile, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;